import { tz } from "moment-timezone";

export function guessUserCountry() {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    for (const country of tz.countries()) {
        const timeZones = tz.zonesForCountry(country);
        if (timeZones.includes(userTimeZone)) {
            return country.toUpperCase();
        }
    }

    return "US";
}
